import BaseModel from './BaseModel';
import * as AT from '../../components/container/attributes';
import {required} from '@vuelidate/validators';
import {HitOnlineEnums} from 'hit-online-web-ui/src/helpers/constants';
import {translate} from '../../plugins/i18n/i18n';
import MultiLanguageDesignationModel from './MultiLanguageDesignationModel';
import {HitUtils} from '@hit/components/src/utils/hit/HitUtils';

export default class Journal extends MultiLanguageDesignationModel {
  constructor({
    id,
    number,
    active,
    journalType,
    transactionType,
    periodicNumbering,
    periodicNumberingLength,
    nextDocumentNumber,
    designation = undefined,
    designationFrBe = undefined,
    designationDeBe = undefined,
    designationNlBe = undefined,
    designationFrLu = undefined,
    designationDeLu = undefined,
    designationFrFr = undefined,
    designationDeDe = undefined,
    designationNlNl = undefined,
    designationEnGb = undefined,
    designationEnIn = undefined,
    designationMrIn = undefined,
    designationHiIn = undefined,
  }) {
    super({
      id,
      number,
      designationFrBe,
      designationDeBe,
      designationNlBe,
      designationFrLu,
      designationDeLu,
      designationFrFr,
      designationDeDe,
      designationNlNl,
      designationEnGb,
      designationEnIn,
      designationMrIn,
      designationHiIn,
    });
    if (designation) {
      this.designation = designation;
    }
    this.active = active;
    this.journalType = journalType
      ? HitOnlineEnums.getEnumValue('JOURNAL_TYPE', journalType, translate)
      : null;
    this.transactionType = transactionType
      ? HitOnlineEnums.getEnumValue(
          'TRANSACTION_TYPE',
          transactionType,
          translate,
        )
      : null;
    this.periodicNumbering = periodicNumbering;
    this.periodicNumberingLength = periodicNumberingLength;
    this.nextDocumentNumber = nextDocumentNumber;
  }

  get fastModeBrowserDesignation() {
    return HitUtils.createStandardDesignation({
      number: this.number,
      designation: this.designationForLocale(this.displayLocale),
    });
  }

  static get config() {
    const config = BaseModel.config;
    config['importable'] = false;
    return config;
  }
  get config() {
    return Journal.config;
  }

  static get fkName() {
    return 'journal_id';
  }
  static get apiRoute() {
    return 'journal';
  }
  static get detailPageRoute() {
    return 'journalDetail';
  }
  static get listPageRoute() {
    return 'journalList';
  }
  get fkName() {
    return Journal.fkName;
  }
  get apiRoute() {
    return Journal.apiRoute;
  }
  get listPageRoute() {
    return Journal.listPageRoute;
  }
  get detailPageRoute() {
    return Journal.detailPageRoute;
  }

  static get joinAttrsKey() {
    return [
      'number',
      ...this.localeAttributeNames('designation'),
      'journalType',
      'transactionType',
    ];
  }

  static get listDisplayAttrs() {
    return this.getAttributes([
      'number',
      this.attributeUserLocale('designation'),
      this.attributeCompanyLocale('designation'),
      'periodicNumbering',
      'nextDocumentNumber',
      'periodicNumberingLength',
      'active',
    ]);
  }

  static get browserDisplayAttrs() {
    return this.getAttributes(
      [
        'number',
        ...this.localeAttributeNames('designation'),
        'journalType',
        'transactionType',
      ],
      [],
    );
  }

  static get createInitColumns() {
    return {
      [this.attributeCompanyLocale('designation', true)]: '',
      periodic_numbering: false,
      active: true,
      next_document_no: 1,
    };
  }

  static get allAttributes() {
    return [
      this.NUMBER_ATTRIBUTE({validations: {required}}),
      this.ACTIVE_ATTRIBUTE(),
      new AT.EnumerationAttribute({
        name: 'journalType',
        enumType: 'JOURNAL_TYPE',
        enumClass: HitOnlineEnums,
        column: 'journal_type',
        tableProperties: {
          header: 'hit-app.journal.journal-type',
        },
      }),
      new AT.EnumerationAttribute({
        name: 'transactionType',
        enumType: 'TRANSACTION_TYPE',
        enumClass: HitOnlineEnums,
        column: 'transaction_type',
        tableProperties: {
          header: 'hit-app.transaction.transaction-type',
        },
      }),
      new AT.BooleanAttribute({
        name: 'periodicNumbering',
        column: 'periodic_numbering',
        tableProperties: {
          header: 'hit-app.journal.periodic-numbering',
        },
      }),
      new AT.DecimalAttribute({
        name: 'nextDocumentNumber',
        column: 'next_document_no',
        validations: {required},
        decimalPrecision: 0,
        creationValue: 1,
        tableProperties: {
          header: 'hit-app.journal.next-document-number',
        },
      }),
      new AT.DecimalAttribute({
        name: 'periodicNumberingLength',
        column: 'periodic_numbering_length',
        validations: {required},
        decimalPrecision: 0,
        creationValue: 3,
        tableProperties: {
          header: 'hit-app.journal.numbering-length',
        },
      }),
    ].concat(
      this.generateMultiLanguageField({
        key: 'designation',
        attributeClass: AT.StringAttribute,
        header: 'hit-base.common.designation',
      }),
    );
  }
}
